docReady(()=>{
	///refactored
	window.addGoodsToCart = function(domain, goodsId, type = 1, data = {}, callback = function () {}) {
		$.ajax({
			url: domain+'shop_cart/ajax_goods_add/'+goodsId+'/'+type+'.html',
			dataType : "text",
			type : "POST",
			data : data,
			success: function (data, textStatus) {
				callback();
				updateCard(domain);
			}
		});
	}
	window.buttonAddToCartModal = function (e) {
		var element = $(e);
		$('#AddToCartModal').modal('show');
		modalAddToCart.name = element.data('name');
		modalAddToCart.domain = element.data('domain');
		modalAddToCart.id = element.data('id');
		modalAddToCart.image = element.data('image');
		modalAddToCart.currency = element.data('currency');
		modalAddToCart.price = element.data('price');
		modalAddToCart.sum = element.data('price');
		modalAddToCart.origin_currency = element.data('origin_currency');
		modalAddToCart.origin_price = element.data('origin_price');
		modalAddToCart.origin_sum = element.data('origin_price');


	}
	window.updateCard = function (domain) {
		$.ajax({
			url: domain,
			dataType : "html",
			type : "GET",
			success: function (html) {
				var $doc = $(html);
				$('#checkoutNavbar').html($doc.find('#checkoutNavbar').html());
				$('#buy-badge').html($doc.find('#buy-badge').html());
			}
		});
	}
	window.removeFromCard = function (domain, goodsId, type = 1, callback = function () {}) {
		$.ajax({
			url: domain+'/shop_cart/ajax_goods_delete/'+goodsId+'/'+type+'.html',
			dataType : "text",
			type : "POST",
			success: function (data, textStatus) {
				callback();
				updateCard(domain);
			}
		});
	}
	$('body').on('click','.delete-item-from-card',function () {
		$('#checkoutNavbar').removeClass('show');
		removeFromCard($(this).data('domain'),$(this).data('id'), 1);
	});


	///not refactored
		// pagination
		$("#catalogResults")
			.on("click",".itemsPerPage a",function(){
				postVars.perPage = $(this).text();
				postVars.pageNum = 1;
				doCatalogRequest();
				history.pushState({},$('title').text(),$(this).attr("href"));
				return false;
			})
			.on("click",".pages a",function(){
				postVars.pageNum = $(this).text();
				doCatalogRequest();
				history.pushState({},$('title').text(),$(this).attr("href"));
				return false;
			})
			.on('click','.item-sort',function(){
				window.sortType = $(this).data('value');
				orderBy($(this).data('value'));
			}).on('click','.pagination .btn_nav', function (){
			 if(!$(this).hasClass('isDisabled')){
				 postVars.pageNum = $(this).data('value');
				 doCatalogRequest();
				 // // history.pushState({},$('title').text(),$(this).attr("href"));
			 }
		 	return false;
			}).on('change','.country_list input[type="checkbox"]',function(){
				filterCountry($(this).data('id'));
			}).on('change','#cities input[type="checkbox"]',function(){
			filterCity($(this).data('id'));
			}).on('change','.any_params input[type="checkbox"]',function(){
			setfilter($(this).data('id'),$(this).next('span').find('.hide_info').first().text().trim(),this.checked);
			}).on('change','.set_price input',function(){
			setPriceOnly(this.checked);
			}).on('change','.set_vip input',function(){
			setVipOnly(this.checked);
			}).on('click','.others-list button',function(){
			setFloatFilter($(this).data('id'));
		}).on('click','.filters-header-reset-btn',function(){
			clearFilters();
		}).on('click','.close_selected',function(){
			var func_name = $(this).parent().attr('data_mode');
			var id = $(this).parent().attr('data_id');
			switch (func_name) {
				case 'filterCountry':
					filterCountry(id);
					break;
				case 'filterCity':
					filterCity(id);
					break;
				case 'setfilter':
					setfilter(id,$(this).prev('span').text().trim(),false);
					break;
				case 'setPriceOnly':
					setPriceOnly(false);
					break;
				case 'setVipOnly':
					setVipOnly(false);
					break;
			}
		});

// Catalog filters
		// выбор валюты
		$("#curency_switch").on("change","select",doCatalogRequest);
		// Обработчик дерева (сайдбар каталога)
		$("#leftsidebar")
			// Обработчик открытия/закрытия субменю
			.on("click",".tree li>a:first-child",function(){
				var li = $(this).parent();
				var ul = li.children('ul');
				if(li.hasClass('deployed'))
				{
					li.removeClass('deployed');
					ul.hide();
				}
				else
				{
					li.addClass('deployed');
					if(ul.length>0)
						ul.show();
					else
						li
							.append('<ul><li><img src="/public/files/jquery/jstree/1.0rc2/themes/default/throbber.gif"/></li></ul>')
							.children('ul')
							.load(uriCatMnuBranch+'/'+li.attr('id').split('_')[1]);
				}
			})/* Обработчик клика по ссылке
	.on("click",".tree span+a",function(){
		history.pushState({},$(this).text(),$(this).attr("href"));
		$('head>title').text($(this).text());
		treeItemClk($(this).parent().attr('id').split('_')[1]);
		return false;
	}) */
		;

// Вызовы doCatalogRequest()
// pagination call's
	function orderBy(sortType){
		postVars.sortType = sortType;
		postVars.pageNum = 1;
		doCatalogRequest();}
// filters call's
	function filterCountry(id){
		postVars.pageNum = 1;
		postVars.countryList = (postVars.countryList == id)?'':id;
		postVars.cityList = '';
		doCatalogRequest();}
	function filterCity(id){
		postVars.pageNum = 1;
		postVars.cityList = (postVars.cityList == id)?'':id;
		doCatalogRequest();}
	function setfilter(filter,value,remove){
		postVars.pageNum = 1;
		var data = filter+"="+value+"_";
		if(remove)
			postVars.appliedFiltersList+= data;
		else
			postVars.appliedFiltersList = postVars.appliedFiltersList.replace(new RegExp(data.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"),'g'),'');
		doCatalogRequest();}
// tree call's
	function treeItemClk(itemId){
		postVars.catId = itemId;
		postVars.appliedFiltersList = '';
		postVars.pageNum = 1;
		postVars.countryList = '';
		postVars.cityList = '';
		doCatalogRequest();}
// renderType call's
	function setRenderType(value){
		postVars.renderType = value;
		doCatalogRequest();}
// breadcrumbs call's
	function getgoods(catid,goodstype,branchtype){
		postVars.catId = catid;
		postVars.pageNum = 1;
		postVars.appliedFiltersList = '';
		postVars.countryList = '';
		postVars.cityList = '';
		doCatalogRequest();}
// vipOnly call's
	function setPriceOnly(value){
		postVars.priceOnly = (value?1:0);
		postVars.pageNum = 1;
		doCatalogRequest();}
// priceOnly call's
	function setVipOnly(value){
		postVars.vipOnly = (value?1:0);
		postVars.pageNum = 1;
		doCatalogRequest();}
// clear filters
	function clearFilters(){
		postVars.appliedFiltersList = '';
		postVars.pageNum = 1;
		postVars.countryList = '';
		postVars.cityList = '';
		postVars.sortType = 2;
		postVars.vipOnly = 0;
		postVars.priceOnly = 0;
		doCatalogRequest();}
	function setFloatFilter(id){
		var form = $('#float_'+id);
		var max = parseFloat(form.find("input[name=max]").val().replace(',','.'));
		var min = parseFloat(form.find("input[name=min]").val().replace(',','.'));
		var arr = form.find("input[name=data]").val().split('%');
		postVars.appliedFiltersList = postVars.appliedFiltersList.replace(new RegExp(id+"=\\d+_","g"),'');
		for(var i = 0;i<arr.length;i++)
			if((parseFloat(arr[i].replace(',','.')))>=min && (parseFloat(arr[i].replace(',','.')))<=max)
				postVars.appliedFiltersList+= id+"="+arr[i]+'_';
		postVars.pageNum = 1;
		doCatalogRequest();}
	function removeFloatFilter(id){
		postVars.appliedFiltersList = postVars.appliedFiltersList.replace(new RegExp(id+"=\\d+_","g"),'');
		postVars.pageNum = 1;
		doCatalogRequest();}

	function doCatalogRequest(){
		var q = postVars;
		var param = {
			catId:				q.catId,
			goodsType:			q.goodsType,
			goodsIdList:		q.goodsIdList,
			renderType:			q.renderType,
			vipOnly:			q.vipOnly,
			priceOnly:			q.priceOnly,
			sortType:			q.sortType,
			perPage:			q.perPage,
			pageNum:			q.pageNum,
			cityList:			q.cityList,
			countryList:		q.countryList,
			appliedFiltersList:	q.appliedFiltersList,
			currency:			$('#curency_switch').val(),
			offset:				0
		};
		$('#catalogResults')
			.html('<img src="/public/frontend/images/ajax-loader.gif" alt="Loading..." style="margin:0 auto;display:block;" />')
			.load(catalogAjaxUrl,param);
	}

	window.uriCatMnuBranch = '/catalog/branch';
	postVars ={
		catId:				0,
		goodsType:			'',
		renderType:			3,
		sortType:			2,
		perPage:			10,
		pageNum:			1,
		vipOnly:			0,
		priceOnly:			0,
		cityList:			'',
		countryList:		'',
		appliedFiltersList:	'',
		goodsIdList:		''
	};
});